import { httpClient } from '@/infra/protocols/http';

export async function requestProjectAccess(params: RequestProjectAccessService.Params) {
  await httpClient.post<void>(`/v1/projetos/${params.projectId}/solicitacao`);
}

export namespace RequestProjectAccessService {
  export interface Params {
    projectId: string;
  }
}
